export function data(): string {
  return 'data';
}

export const testingConstants = {
  roomActionsBlock: 'roomActionsBlock',
  formHeader: 'formHeader',
  emptyContentIcon: 'emptyContentIcon',
  meetingsEmptyIcon: 'meetingsEmptyIcon',
  featuresImage: 'featuresImage',
  connectionState: 'connectionState',
  editQueue: 'editQueue',
  managePeople: 'managePeople',
  deleteQueue: 'deleteQueue',
  roomsPage: 'roomsPage',
  deleteApiKey: 'deleteKey',
  copyApiKey: 'copyKey',
  activeMeetingPage: 'activeMeetingPage',
  joinBtn: 'joinBtn',
  spinner: 'spinner',
  guestJoinForm: 'guestJoinForm',
  joinMeetAsUser: 'joinMeetAsUser',
  copyButtonIcon: 'copyButtonIcon',
  goBackToQueues: 'goBackToQueues',
  goBackHomeButton: 'goBackHomeButton',
  roomTitle: 'roomTitle',
  preMeetingContent: 'preMeetingContent',
  roomOfflineBadge: 'roomOfflineBadge',
  startCallsAutomatically: 'startCallsAutomatically',
  joinError: 'joinError',
  preMeetingGoBackButton: 'preMeetingGoBackButton',
  roomsListItem: 'roomsListItem',
  roomsListItemJoinButton: 'roomsListItemJoinButton',
  dropdownButton: 'dropdownButton',
  dropdownOption: 'dropdownOption',
  joinEnterName: 'joinEnterName',
  tosCheckbox: 'tosCheckbox',
  submitLoginBtn: 'submitLoginBtn',
  closingMessageInPreRoom: 'closingMessageInPreRoom',
  roomClosedBadge: 'roomClosedBadge',
  closingMessage: 'example closing message',
  closingMessageInRoomOverview: 'closingMessageInRoomOverview',
  closingMessageSwitch: 'closingMessageSwitch',
  closingMessageInput: 'closingMessageInput',
  createInstantMeeting: 'createInstantMeeting',
  preMeetingPage: 'preMeetingPage',
  tosPreMeeting: 'tosPreMeeting',
  endCall: 'endCall',
  screenShare: 'screenShare',
  screenSharesModalButton: 'screenSharesModalButton',
  stopScreenShareButton: 'stopScreenShareButton',
  screenShareTile: 'screenShareTile',
  stopAllScreenShares: 'stopAllScreenShares',
  meedioLogo: 'meedioLogo',
  meetingTitle: 'meetingTitle',
  help: 'help',
  helpDropdown: 'helpDropdown',
  requestPermissions: 'requestPermissions',
  endCallPopupCloseBtn: 'endCallPopupCloseBtn',
  profileBtn: 'profileBtn',
  logoutBtn: 'logoutBtn',
  toggleAudioButton: 'toggleAudioButton',
  toggleVideoButton: 'toggleVideoButton',
  noVideoFrame: 'noVideoFrame',
  leaveMeeting: 'leaveMeeting',
  emailInputLogin: 'emailInputLogin',
  usernameInputLogin: 'usernameInputLogin',
  passwordInputLogin: 'passwordInputLogin',
  smsCodeInputValue: '111111',
  smsCodeSubmitBtn: 'smsCodeSubmitBtn',
  smsCodeContainerDiv: 'smsCodeContainerDiv',
  forgotPasswordLink: 'forgotPasswordLink',
  forgotPasswordEmailInput: 'forgotPasswordEmailInput',
  submitForgotPassword: 'submitForgotPassword',
  createPasswordInputFirst: 'createPasswordInputFirst',
  createPasswordInputSecond: 'createPasswordInputSecond',
  createPasswordValue: 'createPasswordValue',
  createPasswordButton: 'createPasswordButton',
  searchInput: 'searchInput',
  helpResults: 'helpResults',
  questionBox: 'questionBox',
  answerBox: 'answerBox',
  timer: 'timer',
  sidebarRooms: 'sidebarRooms',
  createRoomButton: 'createRoomButton',
  roomNameInput: 'roomNameInput',
  submitNewRoomButton: 'submitNewRoomButton',
  confirmAddMembersButton: 'confirmAddMembersButton',
  roomAvailabilityToggle: 'roomAvailabilityToggle',
  optionsDropdown: 'optionsDropdown',
  roomsSearchInput: 'roomsSearchInput',
  roomMembers: 'roomMembers',
  roomMember: 'roomMember',
  memberQueueTime: 'memberQueueTime',
  submitDeleteRoomButton: 'submitDeleteRoomButton',
  autoCallSwitch: 'autoCallSwitch',
  admitNextGuestButton: 'admitNextGuestButton',
  acceptGuestFromQueueButton: 'acceptGuestFromQueueButton',
  roomList: 'roomList',
  memberTabs: 'memberTabs',
  meetingTimer: 'meetingTimer',
  settingsButton: 'settingsButton',
  usersModalButton: 'usersModalButton',
  shareButton: 'shareButton',
  tosContainer: 'tosContainer',
  callEndedPopup: 'callEndedPopup',
  hangupConfirmationPopup: 'hangupConfirmationPopup',
  joiningAsName: 'joiningAsName',
  participantDetails: 'participantDetails',
  preRoomPage: 'preRoomPage',
  micOffIndicator: 'micOffIndicator',
  camOffIndicator: 'camOffIndicator',
  header: 'header',
  roomCopyButton: 'roomCopyButton',
  copyButton: 'copyButton',
  roomSlugInput: 'roomSlugInput',
  roomMemberCheckbox: 'roomMemberCheckbox',
  uiLabelText: 'uiLabelText',
  createApiKeyButton: 'createApiKeyButton',
  confirmCreateApiKeyButton: 'confirmCreateApiKeyButton',
  apiKeyContainer: 'apiKeyContainer',
  secretContainer: 'secretContainer',
  apiKeyDropdown: 'apiKeyDropdown',
  apiKeyFinishButton: 'apiKeyFinishButton',
  deleteApiKeyButton: 'deleteApiKeyButton',
  leaveConversation: 'leaveConversation',
  deleteConversation: 'deleteConversation',
  noOneOperatingQueue: 'noOneOperatingQueue',
  eta: 'eta',
  errorPopup: 'errorPopup',
  organizationSettingsButton: 'organizationSettingsButton',
  apiKeysButton: 'apiKeysButton',
  editMember: 'editMember',
  removeUser: 'removeUser',
  successPageLeaveButton: 'successPageLeaveButton',
  sidebarBoards: 'sidebarBoards',
  waitingListSwitch: 'waitingListSwitch',
  kickButton: 'kickButton',
  forgotPasswordConfirmationElement: 'forgotPasswordConfirmationElement',
  settingsAudioOptions: 'settingsAudioOptions',
  settingsAudioToggle: 'settingsAudioToggle',
  settingsAudioTabButton: 'settingsAudioTabButton',
  closeModalButton: 'closeModalButton',
  continueWithoutDevices: 'continueWithoutDevices',
  chatInput: 'chatInput',
  sendChatMessageButton: 'sendChatMessageButton',
  openChatButton: 'openChatButton',
  headerOptionsButton: 'headerOptionsButton',
  startSyncConfirmationButton: 'startSyncConfirmationButton',
  syncScreenButton: 'syncScreenButton',
  closeSidebarButton: 'closeSidebarButton',
  meetingOptionsButton: 'meetingOptionsButton',
  fullscreenButton: 'fullscreenButton',
  sfuQueue: 'sfuQueue',
  meetingTerminatedPopup: 'meetingTerminatedPopup',
  notificationsIndicator: 'notificationsIndicator',
  participantName: 'participantName',
  messageSender: 'messageSender',
  chatMessage: 'chatMessage',
  matrixHomeserverInput: 'matrixHomeserverInput',
  matrixHomeserverDisplay: 'matrixHomeserverDisplay',
  changeMatrixHomeserverButton: 'changeMatrixHomeserverButton',
  setHomeserverButton: 'setHomeserverButton',
  openSidebarButton: 'openSidebarButton',
  raiseHandToastClose: 'raiseHandToastClose',
  raiseHandIndicator: 'raiseHandIndicator',
  createRoomModal: 'createRoomModal',
  submitFormButton: 'submitFormButton',
  raiseHandButton: 'raiseHandButton',
  hangUpButton: 'hangUpButton',
  peopleSidebarButton: 'peopleSidebarButton',
  confirmKick: 'confirmKick',
  raiseHandToast: 'raiseHandToast',
  chatContent: 'chatContent',
};

export const matrixConstants = {
  MX_DEVICE_ID: 'matrixDeviceId',
  MX_USER_ID: 'matrixUserId',
  MX_ACCESS_TOKEN: 'matrixAccessToken',
};
